import React, { useEffect } from 'react';
import EmptyState from '@atlaskit/empty-state';
import { Text } from '@atlaskit/primitives';
import { getAkEmptyStateRenderImageFn } from '@atlassian/jira-illustrations';
import EmptyStateWorkflowWorkSuggestions from '@atlassian/jira-illustrations/src/ui/adg4/jira/spots/empty/components/empty-state-workflow-work-suggestions';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { PERISCOPE_ANALYTICS } from '../../constants';
import messages from './messages';

export const PeriscopeEmptyState = () => {
	const { formatMessage } = useIntl();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	useEffect(() => {
		fireUIAnalytics(
			createAnalyticsEvent({
				action: 'rendered',
				actionSubject: 'emptyState',
			}),
			`${PERISCOPE_ANALYTICS}.workSuggestions.emptyState`,
		);
	}, [createAnalyticsEvent]);

	return (
		<EmptyState
			header={formatMessage(messages.emptyStateTitleNonFinal)}
			description={
				<>
					<Text as="p">{formatMessage(messages.emptyStateDescriptionPrimaryNonFinal)}</Text>
					<Text as="p">{formatMessage(messages.emptyStateCheckAgainLaterNonFinal)}</Text>
				</>
			}
			headingLevel={2}
			renderImage={getAkEmptyStateRenderImageFn(EmptyStateWorkflowWorkSuggestions)}
		/>
	);
};
